(function ($, w, d, undefined) {
    'use strict';

    function Modal() {
        this.modalSelector = '.modal';
        this.modalOverlay = '.modal-overlay';
        this.triggerSelector = '*[data-modal-id]';
        this.btnCloseSelector = '.modal-btn-close';
        this.forceCentred = false;

        this.setEvents();

        var self = this;
        THF.Utility.StateManager.addOnEnter('sm', function() {
            self.forceCentred = true;
            $(self.modalSelector).each(function() {
                $(this).removeClass('centred');
                $(this).removeClass('right');
                $(this).addClass('centred');
            });
        });

        THF.Utility.StateManager.addOnLeave('sm', function() {
            self.forceCentred = false;
            $(self.modalSelector).each(function() {
                $(this).removeClass('right');
                $(this).removeClass('centred');
                $(this).addClass('right');
            });
        });

        THF.Utility.StateManager.addOnFirstRun('xs', function() {
            self.forceCentred = true;
        });

        THF.Utility.StateManager.addOnFirstRun('sm', function() {
            self.forceCentred = false;
        });

        let width = window.innerWidth;
        if(width <= 767){
            this.forceCentred = true;
        }
    }

    Modal.prototype.getSettings = function (element, event) {
        var data = $(element).data();

        var settings = {
            id: data.modalId || null,
            position: data.modalPosition || 'center',
            triggerElement: null
        };

        if (event !== null) {
            settings.triggerElement = event.target;
        }
        return settings;
    };

    Modal.prototype.setEvents = function () {
        var self = this;
        $(this.triggerSelector).unbind('click').bind('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            self.eventTrigger.apply(self, [event, this]);
        });
    };
    Modal.prototype.setCloseEvents = function (modal) {
        var self = this;
        $(this.modalOverlay, modal).unbind('click').bind('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            self.close(modal);
        });
        $(this.btnCloseSelector, modal).unbind('click').bind('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            self.close(modal);
        });
    };

    Modal.prototype.eventTrigger = function (event, element) {
        var settings = this.getSettings(element, event);
        if (settings.id !== null) {
            var modal = $('#' + settings.id);
            this.open(modal, settings);
            this.setCloseEvents(modal);
        }
    };

    Modal.prototype.close = function (modal) {
        $('html').removeClass('modal-active');
        modal.removeClass('centred');
        modal.removeClass('right');
        modal.hide();
    };

    Modal.prototype.open = function (modal, settings) {
        $('html').addClass('modal-active');

        if (settings.position === 'right' && !this.forceCentred) {
            modal.addClass('right');
            var content = $('.modal-content', modal);
            content.css({
                'position': 'absolute',
                'left': -10000,
                'top': -10000
            });
            modal.show();
            var masterContent = $('#master-content');
            var masterContentProps = masterContent.offset();
            var triggerElem = $(settings.triggerElement);
            var triggerProps = triggerElem.offset();
            var triggerWidth = triggerElem.width();
            content.css({
                'left': (triggerProps.left + triggerWidth) + 'px',
                'top': ((triggerProps.top - (content.height() / 2)) - masterContentProps.top) + 'px'
            });
        }
        else {
            modal.addClass('centred');
            modal.show();
        }


    };


    w.THF = w.THF || {};
    w.THF.Interface = w.THF.Interface || {};
    w.THF.Interface.Modal = Modal;
})(jQuery, window, document);